export var CostDataGroupBy;
(function (CostDataGroupBy) {
    CostDataGroupBy["COST_GROUP_BY_SOURCE_ACCOUNT"] = "SOURCE_ACCOUNT";
    CostDataGroupBy["COST_GROUP_BY_CLOUD_PROVIDER"] = "CLOUD_PROVIDER";
    CostDataGroupBy["COST_GROUP_BY_RESOURCE_TYPE"] = "RESOURCE_TYPE";
    CostDataGroupBy["COST_GROUP_BY_RESOURCE"] = "RESOURCE";
    CostDataGroupBy["COST_GROUP_BY_RESOURCE_AND_VAULT"] = "RESOURCE_AND_VAULT";
})(CostDataGroupBy || (CostDataGroupBy = {}));
